<template>
    <div class="commission-setting">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Commission Setting</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <CommissionTable />
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import CommissionTable from '@/views/Configurations/CommissionSettings/CommissionTable'

export default {
    components: {
        CommissionTable,
        RouteBreadCrumb,
    },
    data() {
        return {
        }
    },
}
</script>